import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { tag, toasterStackStyles } from './toaster-stack.styles';

@customElement(tag)
export class ToasterStackComponent extends TmElement {
  static override styles = toasterStackStyles;

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-toaster-stack': ToasterStackComponent;
  }
}
